export const title = "Laporan Pengisian Minyak - Per Jenis Minyak";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [
  {
    name: "dari",
    field: "tanggal_transaksi",
    type: "date",
    format: "yyyy-MM-dd 00:00:00",
    operator: ">=",
    default: new Date(),
    nullable: false,
  },
  {
    name: "sampai",
    field: "tanggal_transaksi",
    type: "date",
    format: "yyyy-MM-dd 23:59:59",
    operator: "<=",
    default: new Date(),
    nullable: false,
  },
];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Jenis",
  field: "data_jenis_minyak.nama",
  data_field: "data_jenis_minyak",
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "TANGGAL",
    field: "tanggal_transaksi",
    type: "date",
    format: "dd MMM yyyy hh:mm",
    width: "w-[16rem]",
    layout: "col-start-start",
  },
  {
    name: "KENDARAAN",
    field: "data_kendaraan",
    type: "string",
    width: "w-[14rem]",
    layout: "col-start-start",
  },
  // {
  //   name: "JENIS MINYAK",
  //   field: "data_jenis_minyak",
  //   type: "string",
  //   width: "w-[12rem]",
  //   layout: "col-start-start",
  // },
  // {
  //   name: "KETERANGAN",
  //   field: "keterangan",
  //   type: "string",
  //   layout: "col-start-start",
  //   width: "w-[26rem]",
  // },
  {
    name: "JLH (LTR)",
    field: "jumlah",
    type: "number",
    width: "w-[12rem]",
    layout: "col-start-end",
  },
  {
    name: "@ HARGA",
    field: "harga_per_liter",
    type: "number",
    width: "w-[12rem]",
    layout: "col-start-end",
  },
  {
    name: "TOTAL",
    field: "total_harga",
    type: "number",
    width: "w-[12rem]",
    layout: "col-start-end",
  },
  {
    name: "KM",
    field: "speedo_akhir",
    type: "number",
    width: "w-[12rem]",
    layout: "col-start-end",
  },
];
